import { useState } from 'react'
import { Link } from 'react-router-dom'
import { AuthService } from '../services/auth'

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')
  const [emailSent, setEmailSent] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    if (!email) {
      setError('メールアドレスを入力してください')
      return
    }

    try {
      setIsLoading(true)
      setError('')
      setMessage('')

      await AuthService.requestPasswordReset(email)

      setEmailSent(true)
      setMessage('パスワードリセットのメールを送信しました。メールをご確認ください。')
    } catch (error: unknown) {
      console.error('Password reset request failed:', error)
      setError('パスワードリセットの送信に失敗しました。メールアドレスを確認してください。')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-md mx-auto px-4 sm:px-6 md:px-8">
        <div className="bg-white rounded-lg shadow-md p-8">
          <div className="text-center mb-8">
            <h1 className="text-2xl font-bold text-gray-900">パスワードリセット</h1>
            <p className="text-gray-600 mt-2">
              登録済みのメールアドレスを入力してください
            </p>
          </div>

          {!emailSent ? (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                  メールアドレス
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  placeholder="student@example.com"
                  required
                />
              </div>

              {error && (
                <div className="bg-red-50 border border-red-200 rounded-md p-3">
                  <div className="text-red-800 text-sm">{error}</div>
                </div>
              )}

              <button
                type="submit"
                disabled={isLoading}
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
              >
                {isLoading ? 'メール送信中...' : 'パスワードリセットメールを送信'}
              </button>
            </form>
          ) : (
            <div className="text-center space-y-4">
              <div className="bg-green-50 border border-green-200 rounded-md p-4">
                <div className="text-green-800">
                  <svg className="w-6 h-6 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  {message}
                </div>
              </div>

              <div className="text-sm text-gray-600">
                <p>メールが届かない場合は以下をご確認ください：</p>
                <ul className="list-disc list-inside mt-2 text-xs space-y-1">
                  <li>迷惑メールフォルダをご確認ください</li>
                  <li>メールアドレスが正しく入力されているかご確認ください</li>
                  <li>しばらく待ってから再度お試しください</li>
                </ul>
              </div>
            </div>
          )}

          <div className="mt-6 text-center">
            <Link
              to="/?login=true"
              className="text-blue-600 hover:text-blue-500 text-sm"
            >
              ログインページに戻る
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForgotPasswordPage